module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"DeleteSuccess":"La liste a bien été supprimée","annotations":{"CANCELED":"Annulation/Refus de la liste","REVIEWED_BY_COOPZONE":"Révision de la liste"}}}')
  delete Component.options._Ctor
}
